import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminUsersStats(period) {
    return useQuery({
        queryKey: adminKeys.usersStats(period),
        queryFn: () => adminApi.getUsersStats(period),
    });
}
